import React, { useState } from 'react';

import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import queryString from 'query-string';

import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Popover from '@material-ui/core/Popover';
import Tooltip from '@material-ui/core/Tooltip';

import classes from './ViewSelector.module.css';

const CoreViewSelector = ({
    activeNavSite,
    history,
    view,
    handleChangeView,
    ...props
}) => {

    const [anchorEl, setAnchorEl] = useState(null);
    const [menuOpen, setMenuOpen] = useState(false);

    const open = Boolean(anchorEl);
    const id = open ? 'nav-select-popover' : undefined;

    const queryValues = queryString.parse(history.location.search);

    const handleClick = event => {
        setAnchorEl(event.currentTarget);
        setMenuOpen(!menuOpen);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setMenuOpen(false);
    };

    const handleSelect = view => {
        handleChangeView(view);
        setAnchorEl(null);
        setMenuOpen(false);
    };

    const renderListOptions = () => {
        switch (queryValues.parentId) {
            case '7e71f5d4-9fbf-4710-8601-e1f11e681479':
                return (
                    <List>
                        <ListItem
                            key={0}
                            onClick={() => handleSelect('Company Client')}
                            classes={{
                                root: classes.ListItem
                            }}
                        >
                            Client
                        </ListItem>
                        <ListItem
                            key={1}
                            onClick={() => handleSelect('Company Site')}
                            classes={{
                                root: classes.ListItem
                            }}
                        >
                            Site
                        </ListItem>
                        <ListItem
                            key={2}
                            onClick={() => handleSelect('Company Equipment')}
                            classes={{
                                root: classes.ListItem
                            }}
                        >
                            Equipment
                        </ListItem>
                    </List>
                );
            case '3ee59a8f-d13a-475b-b424-ee55eef98a65':
                return (
                    <List>
                        <ListItem
                            key={0}
                            onClick={() => handleSelect('Client Site')}
                            classes={{
                                root: classes.ListItem
                            }}
                        >
                            Site
                        </ListItem>
                        <ListItem
                            key={1}
                            onClick={() => handleSelect('Client Equipment')}
                            classes={{
                                root: classes.ListItem
                            }}
                        >
                            Equipment
                        </ListItem>
                        {
                            process.env.contactsEnabled ?
                                <ListItem
                                    key={2}
                                    onClick={() => handleSelect('Client Contact')}
                                    classes={{
                                        root: classes.ListItem
                                    }}
                                >
                                    Contact
                                </ListItem>
                                :
                                null
                        }
                    </List>
                );
            case '33ba6af0-1e7a-4fcf-b75b-f355a01a962b':
                return (
                    <List>
                        <ListItem
                            key={0}
                            onClick={() => handleSelect('Site Equipment')}
                            classes={{
                                root: classes.ListItem
                            }}
                        >
                            Equipment
                        </ListItem>
                        <ListItem
                            key={1}
                            onClick={() => handleSelect('Site System')}
                            classes={{
                                root: classes.ListItem
                            }}
                        >
                            System
                        </ListItem>
                        {
                            process.env.contactsEnabled ?
                                <ListItem
                                    key={2}
                                    onClick={() => handleSelect('Site Contact')}
                                    classes={{
                                        root: classes.ListItem
                                    }}
                                >
                                    Contact
                                </ListItem>
                                :
                                null
                        }
                    </List>
                );
            default:
                return;
        }
    };

    return (
        <div>
            <Button
                className={classes.Button}
                aria-describedby={id}
                onClick={handleClick}
            >
                <Tooltip
                    classes={{ tooltip: classes.tooltip }}
                    title="view"
                    placement="bottom"
                >
                    <div className={classes.Selector}>
                        <p>View - {view} <i className={`fas fa-chevron-${menuOpen ? 'down' : 'up'}`} aria-hidden="true" /></p>
                    </div>
                </Tooltip>
            </Button>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical:   'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical:   'top',
                    horizontal: 'left',
                }}
            >
                <div>
                    {renderListOptions()}
                </div>
            </Popover>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        activeNavSite: state.bob.activeNavSite
    };
};

export default withRouter(connect(mapStateToProps, null)(CoreViewSelector));
